import script from "./IDateSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./IDateSwiper.vue?vue&type=script&setup=true&lang=js"

import "./IDateSwiper.vue?vue&type=style&index=0&id=1d7299d4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7299d4"]])

export default __exports__